export const configBucket = {
    bucketName: 'ecd-files',
    region: 'us-east-2',
    accessKeyId: 'AKIAYOEI6AJQ2ZW37WEH',
    secretAccessKey: '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'
}